import { format, parseISO } from 'date-fns';
import { ko } from 'date-fns/locale';
import { getOrderStatusLabel, getPaymentMethodLabel } from './constants';

// 날짜 포맷팅 함수들
export const formatDate = (dateString, formatStr = 'yyyy년 MM월 dd일') => {
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, formatStr, { locale: ko });
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};

export const formatDateTime = (dateString) => {
  return formatDate(dateString, 'yyyy년 MM월 dd일 HH:mm');
};

export const formatTime = (dateString) => {
  return formatDate(dateString, 'HH:mm');
};

export const formatDateShort = (dateString) => {
  return formatDate(dateString, 'MM/dd');
};

export const formatDateWithDay = (dateString) => {
  return formatDate(dateString, 'yyyy년 MM월 dd일 (EEE)');
};

// 금액 포맷팅 함수들
export const formatCurrency = (amount) => {
  if (typeof amount !== 'number') {
    return '0원';
  }
  return `${amount.toLocaleString('ko-KR')}원`;
};

export const formatCurrencyShort = (amount) => {
  if (typeof amount !== 'number') {
    return '0';
  }

  if (amount >= 100000000) {
    return `${(amount / 100000000).toFixed(1)}억원`;
  }
  if (amount >= 10000) {
    return `${(amount / 10000).toFixed(0)}만원`;
  }
  return `${amount.toLocaleString('ko-KR')}원`;
};

// 전화번호 포맷팅
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }

  return phone;
};

// 주소 포맷팅
export const formatAddress = (address, room = '') => {
  if (!address) return '';
  if (room) {
    return `${address} ${room}`;
  }
  return address;
};

// 상태 표시 텍스트 포맷팅 (orders.json 의 orderStatus 기준 - constants 단일 출처 사용)
export const formatOrderStatus = (status) => getOrderStatusLabel(status);

export const formatPaymentMethod = (method) => getPaymentMethodLabel(method);

// 텍스트 자르기
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
};

// 조회수 포맷팅
export const formatViews = (views) => {
  if (typeof views !== 'number') return '0';

  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}만`;
  }
  if (views >= 1000) {
    return `${(views / 1000).toFixed(1)}천`;
  }
  return views.toString();
};

// 상대 시간 포맷팅 (예: "3시간 전", "2일 전")
export const formatRelativeTime = (dateString) => {
  try {
    const date = parseISO(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return '방금 전';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}분 전`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}시간 전`;
    if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}일 전`;

    return formatDate(dateString, 'yyyy.MM.dd');
  } catch (error) {
    console.error('Error formatting relative time:', error);
    return dateString;
  }
};
